import gql from "graphql-tag";

export const GET_USER_PREFERENCES = gql`
    query UserPreferences($domain: String!) {
        userPreferences(domain: $domain) {
            userId
            domain
            key
            value
            createdAt
            updatedAt
        }
    }
`;

export const GET_USER_PREFERENCE = gql`
    query UserPreference($domain: String!, $key: String!) {
        userPreference(domain: $domain, key: $key) {
            userId
            domain
            key
            value
            createdAt
            updatedAt
        }
    }
`;

export const UPSERT_USER_PREFERENCE = gql`
    mutation UpsertUserPreference($newUserPreference: newUserPreference!) {
        upsertUserPreference(
            newUserPreference: $newUserPreference
        ) {
            returnCode
            message
        }
    }
`;

export const PREPEND_USER_PREFERENCE_LIST = gql`
    mutation PrependUserPreferenceList($newListEntry: newListEntry!) {
        prependUserPreferenceList(
            newListEntry: $newListEntry
        ) {
            returnCode
            message
            obj
        }
    }
`;

export const DELETE_USER_PREFERENCE = gql`
    mutation DeleteUserPreference($domain: String!, $key: String!) {
        deleteUserPreference(
            domain: $domain
            key: $key
        ) {
            returnCode
            message
        }
    }
`;
